/**
 * Created by Arif Topcu in 2019
 */

import React, { useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import { setDefinition as setRatingDefinition } from "state/ratings/actions";
import { getDefault } from "state/ratings/RatingDefinition";
import { selectDefinitions } from "state/ratings/selectors";
import SelectionState from "state/selections/SelectionState";
import RatingsSelectorComplication from "./RatingsSelectorComplication";

const RatingsSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definition, idx) => dispatch(setRatingDefinition(definition, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      getDefaultDefinition={getDefault}
      setDefinition={setDefinition}
      ComplicationComponent={RatingsSelectorComplication}
      btnTitle="Ratings"
      addMoreText="Ratings Column"
    />
  );
};

export default RatingsSelector;
